import { render } from "./ChangePlayer.vue?vue&type=template&id=4586fadd&scoped=true"
import script from "./ChangePlayer.vue?vue&type=script&lang=ts"
export * from "./ChangePlayer.vue?vue&type=script&lang=ts"

import "./ChangePlayer.vue?vue&type=style&index=0&id=4586fadd&scoped=true&lang=less"
import "./ChangePlayer.vue?vue&type=style&index=1&id=4586fadd&lang=less"
script.render = render
script.__scopeId = "data-v-4586fadd"

export default script